import React, { memo } from "react";
import ServiceBackground from "./components/ServiceBackground";
import ServiceContent from "./components/ServiceContent";

const ServicePage = memo(() => {
  console.log('🎨 ServicePage 렌더링');
  
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* 배경 비디오 */}
      <ServiceBackground />
      
      {/* 텍스트 콘텐츠 오버레이 */}
      <ServiceContent />
    </div>
  );
});

// displayName 설정 (디버깅 시 유용)
ServicePage.displayName = 'ServicePage';

export default ServicePage;